import { isNonEmptyString } from "../../../../helpers/fp";

const hasFeaturedHeaderMedia = (featuredHeader) =>
  Boolean(
    isNonEmptyString(featuredHeader?.app?.imageUrl) ||
    isNonEmptyString(featuredHeader?.app?.videoAssetId) ||
    isNonEmptyString(featuredHeader?.web?.imageUrl) ||
    isNonEmptyString(featuredHeader?.web?.videoAssetId),
  );

export default (state) => {
  const featuredHeader = state.category.details?.featuredHeader;

  return featuredHeader?.isEnabled && hasFeaturedHeaderMedia(featuredHeader)
    ? featuredHeader
    : false;
};
